import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M716.582453,133 C929.35232,133 1102.43454,306.082223 1102.43454,518.85209 L1102.43454,518.85209 L1102.43454,629.095544 C1102.43454,745.843362 1049.2972,849.361966 966.945338,920.248507 C1026.69729,927.414332 1086.22876,936.454295 1145.209,948.801562 C1312.00735,983.969224 1433.16491,1143.05053 1433.16491,1327.1571 L1433.16491,1327.1571 L1433.16491,1538.93477 L1410.67524,1555.47129 C1289.73817,1644.21727 1043.45429,1787.86449 715.700505,1787.86449 C698.502526,1787.86449 680.863574,1787.42352 663.224621,1786.65181 C374.386771,1773.09187 155.333027,1653.47772 22.3794212,1555.36105 L22.3794212,1555.36105 L0,1538.82453 L0,1327.04685 C0,1142.94028 121.2678,983.85898 288.17639,948.691318 C346.825907,936.454295 406.136886,926.973358 465.668351,919.69729 C383.647221,848.920992 330.730363,745.622876 330.730363,629.095544 L330.730363,629.095544 L330.730363,518.85209 C330.730363,306.082223 503.812586,133 716.582453,133 Z M625.080386,463.730363 C527.404685,463.730363 508.222324,535.719339 440.973817,562.949472 L440.973817,562.949472 L440.973817,629.095544 C440.973817,781.011024 564.556729,904.70418 716.582453,904.70418 C868.608176,904.70418 992.191089,781.011024 992.191089,629.095544 L992.191089,629.095544 L992.191089,518.85209 C992.191089,516.316491 991.529628,513.891135 991.419384,511.245292 C988.462655,513.924208 985.534501,516.62902 982.606391,519.333368 L980.654011,521.135908 C951.684524,547.863989 922.099403,573.973817 864.308682,573.973817 C744.143316,573.973817 744.143316,463.730363 625.080386,463.730363 Z M1842.05788,307.614607 L1488.28663,661.385852 L1330.85898,503.958199 L1252.91686,581.900322 L1488.28663,817.270096 L1920,385.556729 L1842.05788,307.614607 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconPeerGradedSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconPeerGradedSolid, _Component);

  var _super = _createSuper(IconPeerGradedSolid);

  function IconPeerGradedSolid() {
    _classCallCheck(this, IconPeerGradedSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconPeerGradedSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconPeerGraded",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconPeerGradedSolid.displayName = "IconPeerGradedSolid";
  return IconPeerGradedSolid;
}(Component);

IconPeerGradedSolid.glyphName = 'peer-graded';
IconPeerGradedSolid.variant = 'Solid';
IconPeerGradedSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconPeerGradedSolid;
export { IconPeerGradedSolid };